var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.messages),function(msg,index){return _c('span',{key:index},[_c('Message',{attrs:{"message":msg}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }